module.exports = __webpack_public_path__ + "img/121.d0d68a85.jpg";